<template>

  <div class="Safety">

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Safety</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Safety</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">

        <div id="" class="">
          <br>
          <b-row>
            <b-col cols=12>
                <span class="heading">Download Safety related Documents</span>
            </b-col>
          </b-row>
          <hr/>
          <br>
          <ul>
          <li>
              <span>  <b-img src="../assets/pdf-icon-3.png" height="35px" width="35px" style="padding-bottom:0px" />

                 Safety Manual </span>
               <a href="https://www.apdcl.org/website/docs/safety/Safety_Manual_2019_English.pdf" target="_blank">(English |</a>
               <a href="https://www.apdcl.org/website/docs/safety/Safety_Manual_2019_Assamese.pdf" target="_blank"> Assamese |</a>
               <a href="https://www.apdcl.org/website/docs/safety/Safety_Manual_2019_Bengali.pdf" target="_blank"> Bengali)</a>
          </li>
          <br>
          <li>
              <a href="https://www.apdcl.org/website/docs/safety/Sachest2019.pdf" target="_blank">
                <b-img src="../assets/pdf-icon-3.png" height="35px" width="35px" style="padding-bottom:0px" />

                 Sachest manual</a>
          </li>
        </ul>
        <br><br>
    </div>
</div>
  </b-container>
  <br>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
//import MarqueeText from 'vue-marquee-text-component'
//console.log(Banner);


export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}

</script>

<style scoped="true">
.label{

}
.data{
  font-weight: 500;
  color: #e64a19      ;
  font-size: 1.1rem;
  padding-top: 10px;
}

hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
</style>
